import { z } from 'zod';
import superjson from 'superjson';
import type { ScanIssue } from '../../helpers/agentScan';

export const schema = z.object({
  skillName: z.string().min(1),
  skillMdContent: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  safe: boolean;
  issues: ScanIssue[];
  error: string | null;
};

export async function scanSkillBeforeInstall(
  skillName: string,
  skillMdContent: string,
): Promise<OutputType> {
  const res = await fetch('/_api/taskingbot/scan-skill', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: superjson.stringify({ skillName, skillMdContent }),
  });
  const text = await res.text();
  try {
    return superjson.parse<OutputType>(text);
  } catch {
    try {
      return JSON.parse(text);
    } catch {
      return { safe: true, issues: [], error: text };
    }
  }
}
